import { post } from "@nhi/utils"

export async function setNewsletterCookie(
    formId: string,
    newsletterId: string
) {
    const body = JSON.stringify({
        name: formId,
        value: newsletterId
    })

    await post("/api/newsletterCookie", body)
}
